export default "__VITE_ASSET__DmuNxd6k__"